"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useModal = void 0;
var _react = require("react");
var _types = require("./types");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) { n[e] = r[e]; } return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } /**
 * SPDX-FileCopyrightText: © 2019 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
var delay = function delay(fn) {
  return setTimeout(function () {
    fn();
  }, 100);
};
var modalOpenClassName = 'modal-open';
var useModal = exports.useModal = function useModal() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$defaultOpen = _ref.defaultOpen,
    defaultOpen = _ref$defaultOpen === void 0 ? false : _ref$defaultOpen,
    onClose = _ref.onClose;
  var _useState = (0, _react.useState)(defaultOpen),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var _useState3 = (0, _react.useState)([false, false]),
    _useState4 = _slicedToArray(_useState3, 2),
    visible = _useState4[0],
    setVisible = _useState4[1];
  var timerIdRef = (0, _react.useRef)(null);
  var restoreTriggerRef = (0, _react.useRef)(null);

  /**
   * Control the close of the modal to create the component's "unmount"
   * animation and call the onClose prop with delay.
   */
  var handleCloseModal = function handleCloseModal() {
    document.body.classList.remove(modalOpenClassName);
    setVisible([false, true]);
    timerIdRef.current = delay(function () {
      if (onClose) {
        onClose();
      }
      if (restoreTriggerRef.current) {
        restoreTriggerRef.current.focus();
        restoreTriggerRef.current = null;
      }
      setOpen(false);
      setVisible([false, false]);
    });
  };
  var handleOpenModal = function handleOpenModal() {
    document.body.classList.add(modalOpenClassName);
    setOpen(true);
    timerIdRef.current = delay(function () {
      return setVisible([true, true]);
    });
  };
  var handleObserverDispatch = function handleObserverDispatch(type, payload) {
    switch (type) {
      case _types.ObserverType.Close:
        handleCloseModal();
        break;
      case _types.ObserverType.Open:
        handleOpenModal();
        break;
      case _types.ObserverType.RestoreFocus:
        restoreTriggerRef.current = payload;
        break;
      default:
        break;
    }
  };
  var onOpenChange = (0, _react.useCallback)(function (value) {
    if (value) {
      handleOpenModal();
    } else {
      handleCloseModal();
    }
  }, []);
  (0, _react.useEffect)(function () {
    return function () {
      document.body.classList.remove(modalOpenClassName);
      if (timerIdRef.current) {
        clearTimeout(timerIdRef.current);
      }
    };
  }, []);
  return {
    observer: {
      dispatch: handleObserverDispatch,
      mutation: visible
    },
    onClose: handleCloseModal,
    onOpenChange: onOpenChange,
    open: open
  };
};